<template>
  <div class="services py-3">
    <b-container>
      <p class="services__title mb-3 mb-md-4 text-center">Our Main Services</p>

      <!-- Services Carousel -->
      <b-carousel
        id="services-carousel"
        v-model="slide"
        :interval="4000"
        class="services-carousel"
      >
        <b-carousel-slide
          v-for="(slideServices, slideIndex) in currentCarouselSlides"
          :key="slideIndex"
        >
          <template #img>
            <div class="carousel-slide-content">
              <b-row class="justify-content-center">
                <b-col
                  v-for="(service, serviceIndex) in slideServices"
                  :key="serviceIndex"
                  cols="12"
                  :md="isMobile ? '12' : '6'"
                  :lg="isMobile ? '12' : '4'"
                  class="mb-4"
                >
                  <router-link
                    :to="service.path"
                    class="service-card h-100 d-flex flex-column text-decoration-none"
                  >
                    <div class="service-card__img-wrapper">
                      <img
                        :src="service.image"
                        :alt="service.alt"
                        class="service-card__img"
                        :title="service.title"
                      />
                    </div>
                    <div
                      class="service-card__body p-4 d-flex flex-column justify-content-between flex-grow-1"
                    >
                      <h4 class="service-card__title">{{ service.title }}</h4>
                      <p class="service-card__desc">
                        {{ service.description }}
                      </p>
                    </div>
                  </router-link>
                </b-col>
              </b-row>
            </div>
          </template>
        </b-carousel-slide>
      </b-carousel>
    </b-container>
  </div>
</template>

<script>
import installImg from "../assets/imgs/garageservices1.jpg";
import repairImg from "../assets/imgs/garageservices2.jpg";
import spring from "../assets/imgs/spring-repair-service.jpg";
import team from "../assets/imgs/team-photo.png";
import about from "../assets/imgs/about-us.jpg";
import springImage from "../assets/imgs/spring-replacement.webp";
import garage from "../assets/imgs/garage-door(1).jpg";
import cabin from "../assets/imgs/cabin.jpg";
export default {
  name: "MainServices",
  data() {
    return {
      slide: 0,
      isMobile: false,
      services: [
        {
          title:
            "Replacement of Old or Damaged Doors – Fast & Reliable Solutions",
          alt: "Replacement of old or damaged doors service",
          description:
            "From worn-out panels to complete door replacements, we provide fast and dependable services. With genuine parts, upfront pricing, and detailed safety checks, we restore your door's performance with guaranteed satisfaction.",
          image: repairImg,
          path: "/services/replacement-old-damaged-doors",
        },
        {
          title: "Broken Spring Replacement – Safe & Long-Lasting Solutions",
          alt: "Broken garage door spring replacement",
          description:
            "Expert replacement of broken springs with high-quality materials and proper tensioning for safe and reliable operation. Our technicians handle the job with precision to prevent future issues.",
          image: springImage,
          path: "/services/broken-spring-replacement",
        },
        {
          title: "Cable Repair & Replacement – Precision & Durability",
          alt: "Garage door cable repair service",
          description:
            "Professional repair and replacement of garage door cables to ensure smooth and secure operation. We use high-tensile cables and perform thorough inspections for optimal safety.",
          image: spring,
          path: "/services/cable-repair-replacement",
        },
        {
          title: "Panel Replacement – Restore Strength & Aesthetics",
          alt: "Garage door panel replacement service",
          description:
            "Seamless replacement of damaged panels to match your door's original design and functionality. We focus on quality materials for enhanced durability and visual appeal.",
          image: garage,
          path: "/services/panel-replacement",
        },
        {
          title: "Roller and Hinge Repair – Smooth Operation Guaranteed",
          alt: "Garage door roller and hinge repair service",
          description:
            "Comprehensive repair of rollers and hinges to eliminate noise, improve alignment, and extend your door's lifespan. Our service includes lubrication and adjustments for quiet performance.",
          image: cabin,
          path: "/services/roller-and-hinge-repair",
        },
        {
          title: "Track Alignment and Repair – Precision Adjustments",
          alt: "Garage door track alignment and repair service",
          description:
            "Expert alignment and repair of garage door tracks to prevent misalignment and ensure effortless operation. We identify and fix issues for long-term reliability.",
          image: about,
          path: "/services/track-alignment-and-repair",
        },
        {
          title: "Opener Repair and Troubleshooting – Smart & Secure Fixes",
          alt: "Garage door opener repair service",
          description:
            "Professional troubleshooting and repair of garage door openers, including motor issues and sensor problems. We enhance security and convenience with reliable solutions.",
          image: team,
          path: "/services/opener-repair-and-troubleshooting",
        },
        {
          title: "Remote and Keypad Programming – Easy Access Control",
          alt: "Garage door remote and keypad programming service",
          description:
            "Seamless programming of remotes and keypads for secure and convenient access. We ensure compatibility and provide guidance for easy setup and management.",
          image: springImage,
          path: "/services/remote-and-keypad-programming",
        },
        {
          title:
            "Fast Response for Stuck or Non-Functioning Doors – 24/7 Emergency Service",
          alt: "Emergency garage door service",
          description:
            "24/7 emergency response for stuck or non-functioning doors. We arrive quickly to diagnose and resolve issues, restoring your security and peace of mind anytime.",
          image: repairImg,
          path: "/services/emergency-stuck-doors",
        },
      ],
    };
  },
  computed: {
    currentCarouselSlides() {
      const itemsPerSlide = this.isMobile ? 1 : 3;
      const slides = [];
      for (let i = 0; i < this.services.length; i += itemsPerSlide) {
        slides.push(this.services.slice(i, i + itemsPerSlide));
      }
      return slides;
    },
  },
  mounted() {
    this.checkScreenSize();
    window.addEventListener("resize", this.checkScreenSize);
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.checkScreenSize);
  },
  methods: {
    checkScreenSize() {
      this.isMobile = window.innerWidth <= 768;
      // Reset slide to 0 when screen size changes to avoid index issues
      this.slide = 0;
    },
  },
};
</script>

<style lang="scss" scoped>
.services {
  &__title {
    font-size: 42px;
    font-weight: 800;
    letter-spacing: -0.5px;
  }
  @media (max-width: 768px) {
    &__title {
      font-size: 36px;
    }
  }

  @media (max-width: 400px) {
    &__title {
      font-size: 28px;
      font-weight: 600;
    }
  }
}

.services-carousel {
  .carousel-slide-content {
    padding: 40px 20px;
    min-height: 500px;
  }
}

.service-card {
  background: #ffffff;
  border-radius: 16px;
  overflow: hidden;
  box-shadow: 0 6px 24px rgba(0, 0, 0, 0.08);
  transition: transform 0.25s ease, box-shadow 0.25s ease;
  margin: 0 10px;

  display: flex;
  flex-direction: column;

  &:hover {
    transform: translateY(-8px);
    box-shadow: 0 12px 32px rgba(0, 0, 0, 0.15);
  }

  &__img-wrapper {
    width: 100%;
    height: 240px;
    overflow: hidden;

    img {
      width: 100%;
      height: 100%;
      object-fit: cover;
      transition: transform 0.4s ease;
    }
  }

  &:hover img {
    transform: scale(1.08);
  }

  &__title {
    font-size: 24px;
    font-weight: 700;
    color: #1d1729;
    text-align: center;
    margin-bottom: 12px;
  }

  &__desc {
    font-size: 17px;
    color: #6c6a72;
    line-height: 1.7;
    text-align: center;
    flex-grow: 1;
  }

  &__btn {
    align-self: center;
    padding: 10px 22px;
    border: 2px solid #1d1729;
    border-radius: 8px;
    background: transparent;
    font-size: 15px;
    font-weight: 600;
    color: #1d1729;
    cursor: pointer;
    transition: all 0.25s ease;

    &:hover {
      background: #1d1729;
      color: #ffffff;
    }
  }
}

::v-deep .carousel-indicators {
  bottom: -60px;

  li {
    background-color: rgba(255, 255, 255, 0.5);
    width: 12px;
    height: 12px;
    border-radius: 50%;
    margin: 0 8px;

    &.active {
      background-color: #ffffff;
    }
  }
}

// Responsive adjustments
@media (max-width: 768px) {
  .service-card {
    margin: 0 5px;

    &__title {
      font-size: 20px;
    }

    &__desc {
      font-size: 15px;
    }
  }

  .services-carousel .carousel-slide-content {
    min-height: 400px;
  }
}

@media (max-width: 576px) {
  .services-carousel .carousel-slide-content {
    padding: 20px 10px;
    min-height: 350px;
  }

  .service-card {
    margin: 0;
  }
}
</style>
